import React from "react";
import { useNavigate } from "react-router-dom";

const Course = ({ form }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    // Redirect to a dummy route
    navigate(`/registrationform/${form._id}`); 
  };

  return (
    <div
  onClick={handleCardClick}
  className={`w-[160px] h-[150px] shadow-lg rounded-2xl p-4 flex flex-col justify-center cursor-pointer hover:shadow-xl transition-shadow duration-300 
    ${form.submission_status === "submitted" ? "bg-green-200" : "bg-pink-200"}
  `}
>
  <p className="w-full text-xs text-center mb-[10px]">{form.form_number}</p>
  <p className="w-full text-xs text-center mb-[10px]">{form.student_name || "NEW FORM"}</p>
  <p className="w-full text-xs text-center font-semibold">
    {form.submission_status === "submitted" ? "Submitted" : "Yet to Submit"}
  </p>
</div>
  );
};

export default Course;
